import React from 'react';
import styles from './StudentInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import Dropdown from '../../../../components/Dropdown';
import PhoneInput from '../../../../components/PhoneInput';

const SEX_OPTIONS = [
    { value: 'M', title: 'Masculin' },
    { value: 'F', title: 'Feminin' },
];

const NATIONALITY_OPTIONS = [
    {value : '1', title: 'Française'}, 
    {value : '2', title: 'Union Européenne'},
    {value : '3', title: 'Etranger hors Union Européenne'},
]

const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

const StudentInformations = ({ student, onStudentChange, onDropdownChange }) => {
    return (
        <Card className={styles.card} title="Informations de l'élève" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom"
                    name="last_name"
                    type="text"
                    placeholder="Nom de l'élève"
                    value={student?.last_name || ''}
                    onChange={onStudentChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Nom d'usage"
                    name="usage_name"
                    type="text"
                    placeholder="Nom d'usage"
                    value={student?.usage_name || ''}
                    onChange={onStudentChange}
                />
                <TextInput
                    className={styles.field}
                    label="Prénom"
                    name="first_name"
                    type="text"
                    placeholder="Prénom de l'élève"
                    value={student?.first_name || ''}
                    onChange={onStudentChange}
                    required
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Sexe"
                        name="sex"
                        required
                        options={SEX_OPTIONS}
                        setValue={(option) => onDropdownChange('sex', option.value)}
                        value={SEX_OPTIONS.find(opt => opt.value === student?.sex) || ''}
                    />
                </div>
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Nationalité"
                        name="nationality"
                        options={NATIONALITY_OPTIONS}
                        setValue={(option) => onDropdownChange('nationality', option.value)}
                        value={NATIONALITY_OPTIONS.find(opt => opt.value === student?.nationality) || ''}
                    />
                </div>
                <TextInput
                    className={styles.field}
                    label="Date de naissance"
                    name="birth_date"
                    type="date"
                    value={formatDateForInput(student?.birth_date)}
                    onChange={onStudentChange}
                />
                <TextInput
                    className={styles.field}
                    label="Commune de naissance"
                    name="birth_place"
                    type="text"
                    placeholder="Ville de naissance"
                    value={student?.birth_place || ''}
                    onChange={onStudentChange}
                />
                <TextInput
                    className={styles.field}
                    label="Département de naissance"
                    name="birth_department"
                    type="number"
                    placeholder="Ex: 75"
                    value={student?.birth_department || ''}
                    onChange={onStudentChange}
                />
            </div>
            <div className={styles.divider}></div>
            <PhoneInput
                className={styles.field}
                label="Numéro de téléphone"
                name="phone"
                id="phone"
                placeholder="+33 6 XX XX XX XX"
                value={student.phone || ''}
                onChange={onStudentChange}
                autoComplete="tel"
            />
            <TextInput
                className={styles.field}
                label="Email"
                name="email"
                type="email"
                placeholder="email@example.com"
                value={student?.email || ''}
                onChange={onStudentChange}
                required
            />
        </Card>
    );
};

export default StudentInformations;